import { useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl'
import _get from 'lodash/get';
import cx from 'classnames';
import { IconFilter } from '@/shared/ui/Icons';
import Drawer from '@/shared/ui/Drawer';
import { SwipeHead } from '@/shared/ui/SwipeList';
import WorkersFiltersContent from './WorkersFiltersContent';
import type { WorkersFiltersProps } from './WorkersFilters';
import s from './WorkersFilter.module.scss';
import { hasActiveFilters } from './utils/hasActiveFilters';

const WorkersFiltersMobile = (props: WorkersFiltersProps) => {
  const { className, values = {} } = props;
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const isActive = hasActiveFilters(values);
  const handleShowDrawer = () => { setIsOpen(true); }
  const handleHideDrawer = () => { setIsOpen(false); }

  return (
    <>
      <button 
        onClick={handleShowDrawer}
        className={cx(className, s.btn, {
        [s.isActive]: isActive,
        })}
      >
        <IconFilter color="text-inherit"/>
      </button>
    
      <Drawer
        open={isOpen}
        onInteractOutside={handleHideDrawer}
      >
        <SwipeHead
          title={intl.formatMessage({ id: 'filter.title'})}
          action={<FormattedMessage id="header.cancel"/>}
          onDismiss={handleHideDrawer}
        />
        <WorkersFiltersContent {...props}/>
      </Drawer>        
    </>
  );
}

export default WorkersFiltersMobile;
